export default __webpack_public_path__ + "static/media/VEB_termLifeToAge121.588ff813.jpg";